<form [formGroup]="form" (ngSubmit)="onSave()">
	@if (httpError) {
	<mat-error class="top-right-absolute-error-message">{{ 'masterdata.palletising.dialog.httperror' | translate }}</mat-error>
	}
	<h1 mat-dialog-title class="notification-title">{{ 'masterdata.palletising.zipCodeRules.edit.title' | translate }}</h1>

	<mat-dialog-content class="mat-dialog-content">
		<mat-form-field appearance="outline" class="dialog">
			@if (controls['ruleNumber']?.errors?.['required'] && controls['ruleNumber'].touched) {
			<mat-error>{{ 'masterdata.palletising.zipCodeRules.ruleNumber.errors.empty' | translate }}</mat-error>
			} @if (controls['ruleNumber']?.errors?.['min'] && controls['ruleNumber'].touched) {
			<mat-error>{{ 'masterdata.palletising.zipCodeRules.ruleNumber.errors.min' | translate }}</mat-error>
			} @if (controls['ruleNumber']?.errors?.['max'] && controls['ruleNumber'].touched) {
			<mat-error>{{ 'masterdata.palletising.zipCodeRules.ruleNumber.errors.max' | translate }}</mat-error>
			}
			<mat-label class="mat-body-1">{{ 'masterdata.palletising.zipCodeRules.ruleNumber.name' | translate }}</mat-label>
			<input maxlength="10" OnlyNumbers matInput formControlName="ruleNumber" />
		</mat-form-field>

		<mat-form-field appearance="outline" class="dialog">
			<mat-label class="mat-body-1">{{ 'masterdata.palletising.zipCodeRules.description.name' | translate }}</mat-label>
			<input maxlength="300" [OnlyPattern]="descriptionPattern" matInput formControlName="description" />
		</mat-form-field>

		<mat-form-field appearance="outline" class="dialog">
			@if (controls['from']?.errors?.['required'] && controls['from'].touched) {
			<mat-error>{{ 'masterdata.palletising.zipCodeRules.from.errors.empty' | translate }}</mat-error>
			}

			<mat-label class="mat-body-1">{{ 'masterdata.palletising.zipCodeRules.from.name' | translate }}</mat-label>
			<input maxlength="10" [OnlyPattern]="zipCodePattern" matInput formControlName="from" />
		</mat-form-field>

		<mat-form-field appearance="outline" class="dialog">
			<mat-label class="mat-body-1">{{ 'masterdata.palletising.zipCodeRules.to.name' | translate }}</mat-label>
			<input maxlength="10" [OnlyPattern]="zipCodePattern" matInput formControlName="to" />
		</mat-form-field>
		@if (form.errors?.['invalidZipCodeRange'] && (form.touched || form.dirty)) {
		<mat-error>{{ 'masterdata.palletising.zipCodeRules.errors.invalidRange' | translate }}</mat-error>
		}
	</mat-dialog-content>

	<mat-dialog-actions align="end">
		<button mat-stroked-button type="button" (click)="onCancel()" (window:keyup.escape)="onCancel()" class="button-border-color">{{ 'masterdata.palletising.dialog.cancel' | translate }}</button>
		<button mat-flat-button color="primary" type="submit" [disabled]="loading || form.invalid" [ngClass]="{ 'disabled-button': loading }">{{ 'masterdata.palletising.dialog.ok' | translate }}</button>
	</mat-dialog-actions>
</form>
